'use client';

import { styled } from '@linaria/react';

import useOperatingSystem from '@/hooks/use-operating-system';

function MetaKey() {
  const os = useOperatingSystem();

  const isAppleDevice = os === 'mac' || os === 'ios';

  return isAppleDevice ? <Balloon>⌘</Balloon> : 'Ctrl';
}

// The “⌘” symbol is a little undersized on macOS. Scale it up a bit:
const Balloon = styled.span`
  display: inline-block;
  transform: scale(1.15);
`;

export default MetaKey;
